
import { fetchApi } from "../../../../lib/fetchApi";
import { CampaignDetailsDto } from "../types";
import { ExtractFnReturnType, QueryConfig } from "../../../../lib/react-query";
import { useQuery } from "@tanstack/react-query";
import { FilterDto, FilterType } from '../../../../types/FilterDto';
import { SelectItemDto } from "../../../../types/SelectItemDto";
import { ParticipantCampaignDto } from "../../participants/types";
import { CampaignEndRequestDto, DeleteReasonDto } from "../../../../types/DeleteReasonDto";
import { CampaignDto } from "../types";
import { Pagination, PaginationFilterDto } from "../../../../types/Pagination";
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { SelectedFilter } from "../../../../components/Filters/types";
import i18n from "../../../../i18n";

export const saveCampaign = async (body: CampaignDetailsDto): Promise<CampaignDetailsDto> => {
    const response = await fetchApi.post(`/campaign`, body) as CampaignDetailsDto;
    return response;
}

export const updateCampaign = async (campaignId:number,body: CampaignDetailsDto): Promise<CampaignDetailsDto> => {
    const response = await fetchApi.put(`/campaign/${campaignId}`, body) as CampaignDetailsDto;
    return response;
}

export const getCampaignDetails = async (id: number): Promise<CampaignDetailsDto> => {
    const data = await fetchApi.get(`/campaign/${id}`) as CampaignDetailsDto;
    return data;
}

export const getCampaigns = async (body: PaginationFilterDto): Promise<Pagination<CampaignDto>> => {
    const serializedFilters = body.filters?.map(f => {
        if (!f.dateValues) return f;
        return {
            ...f,
            dateValues: {
                initialDate: f.dateValues.initialDate ? new Date(f.dateValues.initialDate).toISOString() : undefined,
                finalDate: f.dateValues.finalDate ? new Date(f.dateValues.finalDate).toISOString() : undefined,
            }
        };
    });
    const response = await fetchApi.post(`/campaign/search`, { ...body, filters: serializedFilters }) as Pagination<CampaignDto>;
    return response;
};

type CampaignsQueryFn = typeof getCampaigns;
type UseSearchRolesOptions = {
    config?: QueryConfig<CampaignsQueryFn>;
    search?: string;
    filters?: SelectedFilter[];
};

export const useCampaings = ({ config, search = "", filters = [] }: UseSearchRolesOptions = {}) => {
    const historical = useSelector((state: RootState) => state.historical.campaigns);
    const selectedOrganizationalStructureIds = useSelector((state: RootState) => state.currentUserInfo.data.selectedOrganizationalStructureIds);

    return useQuery<ExtractFnReturnType<CampaignsQueryFn>>({
        ...config,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ["campaigns", historical.currentPage, historical.itemsPerPage, search, JSON.stringify(filters), i18n.language, selectedOrganizationalStructureIds],
        queryFn: () =>
            getCampaigns({
                pageNumber: historical.currentPage,
                pageSize: historical.itemsPerPage,
                search,
                filters,
                selectedOrganizationalStructureIds
            }),
    });
};

export const getCampaignNames = async (): Promise<SelectItemDto[]> => {
    return await fetchApi.get(`/campaign/names`) as SelectItemDto[];
}; 

export const getParticipantCampaigns = async (): Promise<ParticipantCampaignDto[]> => {
    return await fetchApi.get(`/campaign/all`) as ParticipantCampaignDto[];
};

export const deleteCampaign = async (idCampaign: number, deleteReason: string): Promise<void> => {
    const body: DeleteReasonDto = {
        deleteReason: deleteReason
    };

    await fetchApi.put(`/campaign/delete/${idCampaign}`, body);
};

export const endCampaign = async (idCampaign: number, body: CampaignEndRequestDto): Promise<void> => {


    await fetchApi.put(`/campaign/end/${idCampaign}`, body);
};

export const getCampaignFilters = async (): Promise<FilterDto[]> => {
  return [
    {
      name: 'StatusCampaing',
      description: 'Estat de la Campanya',
      type: FilterType.MULTIPLE,
      values: [
        { key: "IN_DEFINITION", value: "campaign:campaignStatusInDefinition"},
        { key: "SCHEDULED", value: "campaign:campaignStatusScheduled" },
        { key: "IN_PROGRESS", value: "campaign:campaignStatusInProgress" },
        { key: "COMPLETED", value: "campaign:campaignStatusCompleted" },
        { key: "CANCELLED", value: "campaign:campaignStatusCancelled" }
      ]
    },
    {
      name: 'startDate',
      description: 'startDate',
      type: FilterType.DATE
    },
    {
      name: 'endDate',
      description: 'endDate',
      type: FilterType.DATE
    }
  ];
};



type CampaignFiltersQueryFn = typeof getCampaignFilters;

type UseFiltersOptions = {
    config?: QueryConfig<CampaignFiltersQueryFn>;
};
export const useCampaignFilters = (config?: UseFiltersOptions) =>
    useQuery<ExtractFnReturnType<CampaignFiltersQueryFn>>({
        ...config,
        queryKey: ["campaignFilters"],
        queryFn: () => getCampaignFilters(),
    });